import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Link, Typography } from '@mui/material';

import FooterPublic from '~/components/organisms/FooterPublic/FooterPublic';
import HeaderPublic from '~/components/organisms/HeaderPublic/HeaderPublic';
import { COLORS } from '~/styles/colors';

const DataDeletion = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <HeaderPublic />
      <Box
        sx={{
          backgroundColor: COLORS.white,
          width: '100%',
          pt: 5,
          pb: 5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
          <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
            {t('dataDeletion:deleteAccountTitle')}
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
            {t('dataDeletion:deleteAccountIntro')}
          </Typography>

          <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08, mt: 4 }}>
            {t('dataDeletion:deletingAccount:title')}
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
            {t('dataDeletion:deletingAccount:title2')}
          </Typography>

          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" sx={{ color: COLORS.black08 }}>
              {t('dataDeletion:deletingAccount:step1')}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
              {t('dataDeletion:deletingAccount:step1Desc')}
            </Typography>
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" sx={{ color: COLORS.black08 }}>
              {t('dataDeletion:deletingAccount:step2')}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
              {t('dataDeletion:deletingAccount:step2Desc')}
            </Typography>
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" sx={{ color: COLORS.black08 }}>
              {t('dataDeletion:deletingAccount:step3')}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
              {t('dataDeletion:deletingAccount:step3Desc')}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06, mt: 2 }}>
              {t('dataDeletion:deletingAccount:finalNote')}
            </Typography>
          </Box>

          <Box sx={{ mt: 5 }}>
            <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
              {t('dataDeletion:deletingDataViaFacebook:title')}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
              {t('dataDeletion:deletingDataViaFacebook:title2')}
            </Typography>

            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" sx={{ color: COLORS.black08 }}>
                {t('dataDeletion:deletingDataViaFacebook:step1')}
              </Typography>
              <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                {t('dataDeletion:deletingDataViaFacebook:step1Desc')}
              </Typography>
            </Box>

            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" sx={{ color: COLORS.black08 }}>
                {t('dataDeletion:deletingDataViaFacebook:step2')}
              </Typography>
              <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                {t('dataDeletion:deletingDataViaFacebook:step2Desc')}
              </Typography>
            </Box>

            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" sx={{ color: COLORS.black08 }}>
                {t('dataDeletion:deletingDataViaFacebook:step3')}
              </Typography>
              <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
                {t('dataDeletion:deletingDataViaFacebook:step3Desc')}
              </Typography>
            </Box>

            <Box sx={{ mt: 3 }}>
              <Typography variant="body1" gutterBottom sx={{ color: COLORS.black06 }}>
                {t('dataDeletion:deletingDataViaFacebook:step4Desc')}
              </Typography>
              <Typography variant="body1" sx={{ color: COLORS.black06 }}>
                {t('dataDeletion:deletingDataViaFacebook:step5Desc')}
              </Typography>
            </Box>

            <Box sx={{ mt: 3 }}>
              <Typography variant="body1" paragraph sx={{ color: COLORS.black06, mt: 2 }}>
                {t('dataDeletion:deletingDataViaFacebook:finalNote')}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ mt: 5 }}>
            <Typography variant="h4" gutterBottom sx={{ color: COLORS.black08 }}>
              {t('dataDeletion:requestingDataDeletionManually:title')}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
              {t('dataDeletion:requestingDataDeletionManually.descriptionPart1')}{' '}
              <Link href="mailto:support@qrbrain.io" sx={{ color: COLORS.link }}>
                {t('dataDeletion:requestingDataDeletionManually.descriptionLink')}
              </Link>
              {t('dataDeletion:requestingDataDeletionManually.descriptionPart2')}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
              {t('dataDeletion:requestingDataDeletionManually:requiredInfo')}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
              {t('dataDeletion:requestingDataDeletionManually:step1')}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
              {t('dataDeletion:requestingDataDeletionManually:step2')}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
              {t('dataDeletion:requestingDataDeletionManually:step3')}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06, mt: 2 }}>
              {t('dataDeletion:requestingDataDeletionManually:finalNote')}
            </Typography>
          </Box>

          <Box sx={{ mt: 5 }}>
            <Typography variant="body1" paragraph sx={{ color: COLORS.black06 }}>
              {t('dataDeletion:dataDeletion:contactUsPart1')}{' '}
              <Link href="mailto:support@qrbrain.io" color="primary" underline="hover">
                {t('dataDeletion:dataDeletion:contactUsLink')}
              </Link>{' '}
              {t('dataDeletion:dataDeletion:contactUsPart2')}
            </Typography>
          </Box>
        </Container>
      </Box>
      <FooterPublic />
    </>
  );
};

export default DataDeletion;
